import { ModelDef } from '../../../common/$models/ModelDef'

export const core_server_side_flows: ModelDef = {
  tableName: 'core_server_side_flows',
  tableLabel: 'サーバーサイドフロー',
  primaryKeyColType: 'UUID',
  columns: {
    id: {
      type: 'UUID',
      primaryKey: true,
      editable: false,
    },
    enabled: {
      type: 'BOOLEAN',
      label: '有効状態',
      defaultValue: true,
      width: { xs: 'max-content' },
    },
    category: {
      type: 'STRING',
      label: 'カテゴリ',
    },
    definitionType: {
      type: 'STRING',
      label: '定義タイプ',
      // defaultValue: 'core_server_side_flow',
    },
    key: {
      type: 'STRING',
      label: 'フローキー',
      validate: { notEmpty: true },
      unique: true,
    },
    name: {
      type: 'STRING',
      label: 'フロー名',
      validate: { notEmpty: true },
      width: { xs: 48 },
    },
    description: {
      type: 'TEXT',
      label: '説明',
      width: { xs: 48 },
    },
    nodeConfigs: {
      type: 'JSON',
      label: 'ノード設定',
      defaultValue: [],
      width: { xs: 48 },
      // inputComponent: 'FlowNodeEditor', // カスタムコンポーネントを実装する必要があります
    },
    connections: {
      type: 'JSON',
      label: '接続定義',
      defaultValue: [],
      width: { xs: 48 },
    },
    configureables: {
      type: 'JSON',
      label: '変数定義',
      defaultValue: [],
      width: { xs: 48 },
    },
    metadata: {
      type: 'JSON',
      label: 'メタデータ',
      defaultValue: {},
      width: { xs: 48 },
    },
    otherData: {
      type: 'JSON',
      label: 'その他データ (VirtualModel などで利用)',
      defaultValue: {},
      width: { xs: 48 },
    },
  },
  formColumnGroups: {
    basic: {
      type: 'tab',
      label: '基本情報',
      order: 10,
    },
    flow: {
      type: 'tab',
      label: 'フロー定義',
      order: 20,
    },
    variables: {
      type: 'tab',
      label: '変数',
      order: 30,
    },
  },
  defaultValues: async () => {
    return {
      enabled: true,
      nodes: [],
      connections: [],
      variables: [],
      metadata: {
        category: 'custom',
        tags: [],
      },
    }
  },
  // フロー定義の保存前の検証
  beforeSave: async (saving) => {
    // // 接続の検証
    // const connectionValidationService = new DefaultConnectionValidationService(
    //   new DefaultTypeCompatibilityService(),
    // )

    // for (const connection of saving.connections) {
    //   const sourceNode = saving.nodes.find((n) => n.id === connection.sourceNodeId)
    //   const targetNode = saving.nodes.find((n) => n.id === connection.targetNodeId)

    //   const validationResult = await connectionValidationService.validateConnection(
    //     connection,
    //     sourceNode,
    //     targetNode,
    //   )

    //   if (!validationResult.valid) {
    //     throw new Error(`接続の検証に失敗しました: ${validationResult.errors.join(', ')}`)
    //   }
    // }

    return saving
  },
}
